import Gallery from './components/Gallery.jsx';
import Terms from './components/Terms.jsx';
import ImageLightbox from './components/ImageLightbox.jsx';
import { useState } from 'react';


function App() {
  const [topOpen, setTopOpen] = useState(true);
  const toggleCards = () => {
    topOpen === false? setTopOpen(true) : setTopOpen(false);
  }
  const [imageLightbox, setImageLightbox] = useState(false);
  return (
     <div className="App">
       <div id="siteTitleContainer">
            <h1 id="siteTitle">edsite.black</h1>
            <div className="inline_image_row socials">
            <a href="https://x.com/goodjobrammy" target="_blank"><img width="100" alt="The logo of Twitter, showing a stylized cyan bird, used from 2012-2023." src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Logo_of_Twitter.svg/960px-Logo_of_Twitter.svg.png" /></a>
            <a href="https://bsky.app/profile/edsite.black" target="_blank"><img width="100" alt="Updated Bluesky logo, published February 2024." src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/Bluesky_Logo.svg/960px-Bluesky_Logo.svg.png" /></a>
            <a href="https://yiff.life/@goodjobrammy" target="_blank"><img width="100" alt="logo of the Mastodon social networking software" src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/48/Mastodon_Logotype_%28Simple%29.svg/250px-Mastodon_Logotype_%28Simple%29.svg.png" /></a>
            </div>
            <div id="bgImage"></div>
        </div>
        
          <div id="contentContainer">
            <Gallery topOpen={topOpen} toggleCards={toggleCards} imageLightbox={imageLightbox} setImageLightbox={setImageLightbox} />
            <Terms topOpen={topOpen} toggleCards={toggleCards} imageLightbox={imageLightbox} setImageLightbox={setImageLightbox}/>
          </div>
          {imageLightbox && <ImageLightbox src={imageLightbox} setImageLightbox={setImageLightbox} />}
    </div>
  );
}

export default App;
